const React = require('react')

const IntlPluginContext = React.createContext()

exports.IntlPluginContext = IntlPluginContext
exports.IntlPluginContextProvider = IntlPluginContext.Provider
